import { render, staticRenderFns } from "./master-view.vue?vue&type=template&id=2665c14a&scoped=true"
import script from "./master-view.vue?vue&type=script&lang=js"
export * from "./master-view.vue?vue&type=script&lang=js"
import style0 from "./master-view.vue?vue&type=style&index=0&id=2665c14a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665c14a",
  null
  
)

export default component.exports